import { container } from '@shared/common/dependency-injection/domain/container';
import { AttendeeManagementModuleRoutes } from '@client/feature/attendee-management/application/routes/attendee-management.module-routes';

export const attendeeManagementRoutes = new AttendeeManagementModuleRoutes(container).getRoutes();
